module.exports = __webpack_public_path__ + "assets/img/paySuccess.add5ad70.png";